import { Language } from 'i18n';

export enum LegalDocumentKind {
  TermsAndConditions = 'termsAndConditions',
  PrivacyPolicy = 'privacyPolicy',
  CookiePolicy = 'cookiePolicy',
  SizesChart = 'tableWithChartSizes'
}

interface ILegalDocument {
  url: string
  fileName: string
}

/** PDF served by the client bundle for the given document and language. */
export const getLegalDocument = (kind: LegalDocumentKind, language: string): ILegalDocument => {
  const isBg = language === Language.BG;

  switch (kind) {
    case LegalDocumentKind.TermsAndConditions:
      return isBg
        ? { url: require('assets/files/general-conditions/Общи условия 2_КИДДО.pdf'), fileName: 'Общи условия 2_КИДДО.pdf' }
        : { url: require('assets/files/general-conditions/General Conditions 2_KIDDO.pdf'), fileName: 'General Conditions 2_KIDDO.pdf' };
    case LegalDocumentKind.PrivacyPolicy:
      return isBg
        ? { url: require('assets/files/privacy-policy/ПОЛИТИКА_ЗА_ПОВЕРИТЕЛНОСТВЪВ_ВРЪЗКА_С_ОБРАБОТВАНЕТО_НА_ЛИЧНИ_ДАННИ.pdf'), fileName: 'ПОЛИТИКА_ЗА_ПОВЕРИТЕЛНОСТВЪВ_ВРЪЗКА_С_ОБРАБОТВАНЕТО_НА_ЛИЧНИ_ДАННИ.pdf' }
        : { url: require('assets/files/privacy-policy/Privacy_Policy_2KIDDO.pdf'), fileName: 'Privacy_Policy_2KIDDO.pdf' };
    case LegalDocumentKind.CookiePolicy:
      return isBg
        ? { url: require('assets/files/cookies-policy/ПОЛИТИКА_ЗА_ИЗПОЛЗВАНЕ_НА_БИСКВИТКИ.pdf'), fileName: 'ПОЛИТИКА_ЗА_ИЗПОЛЗВАНЕ_НА_БИСКВИТКИ.pdf' }
        : { url: require('assets/files/cookies-policy/Cookies_policy_2KIDDO.pdf'), fileName: 'Cookies_policy_2KIDDO.pdf' };
    case LegalDocumentKind.SizesChart:
      return isBg
        ? { url: require('assets/files/size-charts/2KIDDO_Size_Charts.pdf'), fileName: '2KIDDO_Size_Charts.pdf' }
        : { url: require('assets/files/size-charts/2KIDDO_Size_Charts_EN.pdf'), fileName: '2KIDDO_Size_Charts_EN.pdf' };
  }
};
